
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils/index";
@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ required: true, default: "" }) url!: any;
  formatUpyunUrl = formatUpyunUrl;
  playing = false;

  clickPlay() {
    this.playing = true;
    var video: any = document.getElementById("myVideo");
    video.play();
  }
}
